import { jsx as _jsx } from "react/jsx-runtime";
import { useAnalytics } from '@hellodarwin/core/lib/features/providers/analytics-provider';
import { useMemo } from 'react';
import { useComponent } from '../../../hooks/useComponent';
import SectionState from '../../common/SectionState';
import HubspotFormEmbed from './embed';
import HubspotFormWrapper from './wrapper';
const HubspotContainer = ({ componentType, entryId, nested, additionalFields, }) => {
    var _a;
    const component = useComponent(entryId, componentType);
    const { containerTag, hubspotId, isLegacy, minHeight, assignedTheme } = (_a = component === null || component === void 0 ? void 0 : component.fields) !== null && _a !== void 0 ? _a : {};
    const { getJourneyData } = useAnalytics();
    const lp_url = getJourneyData('app_first_url');
    const formId = useMemo(() => [`hubspot-form`, containerTag].filter(Boolean).join('-'), [containerTag]);
    if (!component)
        return null;
    if (!hubspotId)
        return null;
    return (_jsx(SectionState, { children: _jsx(HubspotFormWrapper, Object.assign({}, component === null || component === void 0 ? void 0 : component.fields, { removeContainer: nested, children: _jsx(HubspotFormEmbed, { formId: formId, hubspotId: hubspotId, isLegacy: isLegacy, minHeight: minHeight, assignedTheme: assignedTheme, dataLpUrl: lp_url, additionalFields: Object.assign({ hd_lp_url: lp_url !== null && lp_url !== void 0 ? lp_url : '' }, additionalFields) }) })) }));
};
export default HubspotContainer;
